<template>
  <div>
    <h2>Ping Test</h2>
    <v-btn @click="testBackend">Test Backend</v-btn>
    <div v-if="responseMessage">{{ responseMessage }}</div>
    <div v-if="errorMessage" style="color: red;">{{ errorMessage }}</div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      responseMessage: "",
      errorMessage: "",
    };
  },

  methods: {
    async testBackend() {
      console.log("Ping Test 버튼 클릭됨");
      this.responseMessage = ""; // 초기화
      this.errorMessage = ""; // 초기화
      try {
        const response = await axios.get("https://data-labeling.net:4000/ping-test", {
          timeout: 5000, // 타임아웃 설정
        });
        console.log("서버 응답:", response.data);
        this.responseMessage = response.data.message; // 성공 메시지 저장
      } catch (error) {
        console.error("서버 요청 실패:", error); // 에러 로그
        // 에러 메시지 처리
        this.errorMessage =
          error.response?.data?.message || "서버와 연결할 수 없습니다.";
      }
    },
  },
};
</script>

